
import {Vue, Component, Ref} from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import DataEditorDialog from "@/components/helpers/data/editor-dialog.vue";
import {emailAddres, required} from "@/cms-services/consts";
import {mdiPlus} from "@mdi/js";

@Component({
  components: {DataEditorDialog}
})
export default class Access extends Vue {
  @Ref("editor") editor!: DataEditorDialog;

  model: any = {
    email: ''
  };
  $message: any;
  icons: any = {
    plus: mdiPlus,
  };
  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter: JSON.stringify([new Filter("productId", +this.$route.params.courseId)]),
    },
    className: "profileProduct",
  });

  courseDataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.courseId,
    config: {},
    className: "Course",
  });

  loaded: boolean = false;


  createItemModel: any = {
    companyId: +this.$route.params.id,
    caption: "",
    price: "",
  };

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Курсы",
        to: "/manage/courses/",
        exact: true,
      },
      {
        text: this.courseDataSource.model?.caption,
        to: `/manage/courses/${+this.$route.params.courseId}`,
        exact: true,
      },
      {
        text: "Доступы",
      },
    ];
  }

  headers: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },

    {
      text: "Пользователь",
      value: "fullName",
      sortable: true,
    },
    {
      text: "Email",
      value: "email",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  fields: any = [
    {
      editor: "string",
      attrs: {
        type: "text",
        outlined: true,
        label: "Почта пользователя",
      },
      name: "email",
      validations: [required(),emailAddres()],
    },
  ];

  async add() {
    const model: any = await this.editor.update(this.model);
    if (!model) return;
    await this.dataSource.add({
      productId : this.$route.params.courseId,
      email: model.email,
    })
    await this.dataSource.get();
    this.model.email = '';
    this.$message("Успешно добавлено");
  }

  async created() {
    this.dataSource.remove = async (id:any)=>{
      this.$message("Невозможно удалить оплаченный продукт","error");
      throw new Error();
    }

    await Promise.all([this.courseDataSource.get(),this.dataSource.get()]) ;
    this.loaded = true;
  }
}
